export default class ForgotPassword {
    constructor() {
        this.email = "";
        this.mobile = "";
        this.password = "";
        this.confirmPassword = "";
    }
}